module.exports = __webpack_public_path__ + "img/poker-v2.a22cd8f0.jpg";